/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_2_QInputs */

const en_mk_faq_2_q = /** @type {(inputs: Mk_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my company data used to train AI?`)
};

const id_mk_faq_2_q = /** @type {(inputs: Mk_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah data perusahaan saya dipakai untuk melatih AI?`)
};

/**
* | output |
* | --- |
* | "Is my company data used to train AI?" |
*
* @param {Mk_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_2_q = /** @type {((inputs?: Mk_Faq_2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_2_q(inputs)
	return en_mk_faq_2_q(inputs)
});